import { botApi } from './botApi'
import { IChartSettings, IChartTimeInterval } from './types'
import Cookies from 'universal-cookie'
const cookies = new Cookies()
export const chartsApi = botApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getCharts: query<
      | {
          isGeneralChart: false
          byTime: {
            _id: string
            documents: IChartTimeInterval[]
          }[]
          grow: {
            _id: string
            documents: IChartTimeInterval[]
          }[]
          stats?: {
            posProfit: number
            negProfit: number
            count: number
            fullVolume: number
            pureProfit: number
            fee: number
            profit: number
            expectedProfit: number
            expectedProfitPercent: number
            avgTimeBetweenOrders: number
          }
        }
      | {
          isGeneralChart: true
          byTime: IChartTimeInterval[]
          grow: IChartTimeInterval[]
          stats?: {
            posProfit: number
            negProfit: number
            count: number
            fullVolume: number
            pureProfit: number
            fee: number
            profit: number
            expectedProfit: number
            expectedProfitPercent: number
            avgTimeBetweenOrders: number
          }
        },
      {
        settings: IChartSettings
        showGeneralChart: boolean
        timeInterval: string
        isWithChart: boolean
      }
    >({
      query: body => ({
        url: '/charts',
        method: 'POST',
        body,
      }),
      transformErrorResponse: res => {
        if (res.status === 401) {
          cookies.remove('HIDDEN_TOKEN')
        }
      },
    }),
    getChartsOfInvestors: query<
      {
        investors: {
          _id: {
            createdAt: number
            name: string
            fee: number
            token_balance: number
          }
          pureProfit: number
        }[],
        total_token_balance: number
      },
      {
        settings: IChartSettings
        showGeneralChart: boolean
        timeInterval: string
        isWithChart: boolean
        username: string
      }
    >({
      query: body => ({
        url: '/charts/byInvestors',
        method: 'POST',
        body,
      }),
      transformErrorResponse: res => {
        if (res.status === 401) {
          cookies.remove('HIDDEN_TOKEN')
        }
      },
    }),
    getInvestChart: query<
      { _id: string; date: number; total_balance: number; LBT_price: number; LBT_balance: number }[],
      {
        showAll: boolean
        last24h: boolean
        lastHour: boolean
        startTime?: number
        endTime?: number
      }
    >({
      query: body => ({
        url: '/charts/investChart',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useGetChartsQuery, useGetChartsOfInvestorsQuery, useGetInvestChartQuery } = chartsApi
